import React from "react";
import styles from "./PictureCard.module.scss";
import clsx from "clsx";
import { ImageRatio } from "../ImageRatio/ImageRatio";
import { BackgroundColor, classForBackground } from "../Backgrounds/background";

export type PictureCardBorderColors = "transparent" | "destination";
export interface PictureCardProps {
  borderColor?: PictureCardBorderColors;
  trackingName?: string;
  background?: BackgroundColor;
}

export const PictureCard: React.FC<
  React.PropsWithChildren<PictureCardProps>
> = ({
  borderColor = "transparent",
  background = "white",
  trackingName,
  children
}) => {
  const bgClass = classForBackground(background);
  return (
    <div
      className={clsx(styles.pictureCard, bgClass, {
        [styles.withBorder]: borderColor != "transparent"
      })}
      data-content-name={trackingName}
    >
      {children}
    </div>
  );
};

export const PictureCardImage: React.FC<React.PropsWithChildren<unknown>> = ({
  children
}) => {
  return <ImageRatio ratio="card">{children}</ImageRatio>;
};

export const PictureCardTitle: React.FC<React.PropsWithChildren<unknown>> = ({
  children
}) => {
  return <h3 className={styles.title}>{children}</h3>;
};
